import { css } from 'styled-components';
import borderRadiusCss from './borderRadius.css';

export const borderRadiusTokens = css`
  ${borderRadiusCss}
`;

export type BorderRadius =
  | 'border-radius-00'
  | 'border-radius-01'
  | 'border-radius-02'
  | 'border-radius-03'
  | 'border-radius-04'
  | 'border-radius-05'
  | 'border-radius-rounded';
